import React, { useState, useEffect } from "react";
import { HiOutlineArrowNarrowRight } from "react-icons/hi";
import { motion } from "framer-motion";
import { db } from "../components/firebase/firebase";
import {
  collection,
  getDocs,
  updateDoc,
  doc,
  increment,
} from "firebase/firestore";
import Loader from "../components/common/Loader";
import LogoImg from "../components/assets/images/logo-black.png";
import Modals from "../components/common/Modals";

export const Practice = () => {
  const [papers, setPapers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    const fetchPapers = async () => {
      try {
        const papersCollection = collection(db, "resources");
        const papersSnapshot = await getDocs(papersCollection);
        setPapers(
          papersSnapshot.docs.map((docSnap) => ({
            id: docSnap.id,
            ...docSnap.data(),
          }))
        );
      } catch (error) {
        console.error("Error fetching papers:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchPapers();
  }, []);

  const getCoverImage = (item) =>
    item.thumbnail || ""; // or LogoImg placeholder

  const handleViewPaper = async (paper) => {
    try {
      const paperRef = doc(db, "resources", paper.id);
      await updateDoc(paperRef, {
        views: increment(1),
      });
      setPapers((prev) =>
        prev.map((p) =>
          p.id === paper.id ? { ...p, views: (p.views || 0) + 1 } : p
        )
      );
    } catch (error) {
      console.error("Error updating view count:", error);
    }
  };

  const filtered = searchTerm
    ? papers.filter(
        (paper) =>
          paper.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
          (paper.subject &&
            paper.subject.toLowerCase().includes(searchTerm.toLowerCase()))
      )
    : papers;

  const groupPapers = (list) => {
    const grouped = {};
    list.forEach((paper) => {
      const grade = paper.grade;
      const subject = paper.subject || "all";
      const type = paper.type || "";
      if (!grouped[grade]) grouped[grade] = { type, subjects: {} };
      if (!grouped[grade].subjects[subject])
        grouped[grade].subjects[subject] = [];
      grouped[grade].subjects[subject].push(paper);
    });
    Object.keys(grouped).forEach((grade) => {
      Object.keys(grouped[grade].subjects).forEach((subj) => {
        grouped[grade].subjects[subj].sort((a, b) => {
          const dA = new Date(a.year, new Date(a.month + " 1, 2024").getMonth());
          const dB = new Date(b.year, new Date(b.month + " 1, 2024").getMonth());
          return dB - dA;
        });
      });
    });
    return grouped;
  };

  if (loading) return <Loader />;

  const groupedPapers = groupPapers(filtered);

  return (
    <>
      {/* ─── CONNECT WITH US BAR ─── */}
      <div className="bg-blue-600 py-2">
        <div className="container mx-auto px-4 flex flex-wrap justify-center gap-6 items-center">
          <a href="https://www.facebook.com/groups/2539806196195532/?ref=share&mibextid=NSMWBT" aria-label="Facebook">
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/1/1b/Facebook_icon.svg"
              alt="Facebook"
              className="w-6 h-6 sm:w-8 sm:h-8 lg:w-10 lg:h-10"
            />
          </a>
          <a href="https://youtube.com/@ravitestpapers?si=C8smjrPiXabNI54Y" aria-label="Instagram">
            <img
              src="https://img.freepik.com/premium-vector/round-youtube-logo-isolated-white-background_469489-983.jpg?semt=ais_hybrid&w=740"
              alt="Youtube"
              className="w-6 h-6 sm:w-8 sm:h-8 lg:w-10 lg:h-10"
            />
          </a>
          <a href="https://twitter.com/Ravimathssir" aria-label="Twitter">
            <img
              src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTiHIZuDb--IJ-q5d97gWm1W2eyLj7BePcWnQ&s"
              alt="Twitter"
              className="w-6 h-6 sm:w-8 sm:h-8 lg:w-10 lg:h-10"
            />
          </a>
          <a href="http://www.linkedin.com/in/ravi-s-093838310" aria-label="LinkedIn">
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/c/ca/LinkedIn_logo_initials.png"
              alt="LinkedIn"
              className="w-6 h-6 sm:w-8 sm:h-8 lg:w-10 lg:h-10"
            />
          </a>
          <a href="https://wa.me/qr/DO3TUISQWWSCH1" aria-label="WhatsApp">
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
              alt="WhatsApp"
              className="w-6 h-6 sm:w-8 sm:h-8 lg:w-10 lg:h-10"
            />
          </a>
          <a href="https://t.me/FREESTUDYMATERIALSRAVISIR" aria-label="Telegram">
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/8/82/Telegram_logo.svg"
              alt="Telegram"
              className="w-6 h-6 sm:w-8 sm:h-8 lg:w-10 lg:h-10"
            />
          </a>
          <a href="https://WWW.ravitestpapers.in" aria-label="Website">
            <img
              src="https://i.pinimg.com/736x/86/c3/05/86c30529904c3a992eb7241299e5f3e5.jpg"
              alt="Website"
              className="w-6 h-6 sm:w-8 sm:h-8 lg:w-10 lg:h-10"
            />
          </a>
        </div>
      </div>

      {/* Ad Modal */}
      <Modals />

      <section className="courses bg-[#F3F4F8] py-16">
        <div className="w-4/5 mx-auto">
          {/* Header */}
          <div className="flex flex-wrap justify-between items-center mb-16">
            <div className="heading">
              <h1 className="text-3xl font-semibold text-black">
                Free Practice
              </h1>
              <span className="text-sm mt-2 block">
                Work on your skills and improve your knowledge with our free
                papers.
              </span>
            </div>
            <div className="search flex items-center mt-4 sm:mt-0">
              <input
                type="text"
                placeholder="Search papers..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="p-2 border border-gray-300 rounded"
              />
              <button className="ml-2 p-2 bg-blue-600 text-white rounded">
                Search
              </button>
            </div>
          </div>

          {/* Grouped Papers */}
          {Object.keys(groupedPapers).map((grade) => (
            <div key={grade} className="mt-6">
              <h2 className="text-2xl font-semibold text-indigo-500 mb-4">
                {grade.toUpperCase()}{" "}
                {groupedPapers[grade].type.toUpperCase()}
              </h2>
              {Object.keys(groupedPapers[grade].subjects).map((subject) => (
                <div key={subject} className="mt-4">
                  {subject !== "all" && (
                    <h3 className="text-xl font-semibold text-gray-600 mb-2">
                      {subject.toUpperCase()}
                    </h3>
                  )}
                  <div className="grid grid-cols-3 gap-8 md:grid-cols-1">
                    {groupedPapers[grade].subjects[subject].map(
                      (item, idx) => (
                        <motion.div
                          key={idx}
                          className="box rounded-lg shadow-shadow1 bg-white"
                          initial={{ opacity: 0, y: 50 }}
                          animate={{ opacity: 1, y: 0 }}
                          transition={{ duration: 0.5, delay: idx * 0.1 }}
                        >
                          <div className="images rounded-t-lg relative overflow-hidden h-40 w-full">
                            <img
                              src={getCoverImage(item) || LogoImg}
                              alt=""
                              className="rounded-t-lg object-cover w-full h-full transition-transform hover:scale-125 duration-300"
                            />
                            <div className="categ flex gap-4 absolute top-0 m-3">
                              <span className="text-[14px] bg-rose-500 p-1 px-3 text-white rounded">
                                {item.subject}
                              </span>
                              <span className="text-[14px] bg-green-500 p-1 px-3 text-white rounded">
                                {item.month} {item.year}
                              </span>
                            </div>
                          </div>
                          <div className="text p-3">
                            <h3 className="text-black my-4 font-medium h-10">
                              {item.title}
                            </h3>
                          </div>
                          <div className="flex items-center justify-between border-t border-gray-200 p-3">
                            <div className="flex flex-col">
                              {item.referenceLink && (
                                <a
                                  href={item.referenceLink}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="text-[14px] hover:text-primary"
                                >
                                  Free Answer
                                </a>
                              )}
                              <span className="text-[14px] text-gray-600 mt-1">
                                Views: {item.views || 0}
                              </span>
                            </div>
                            <a
                              href={item.link}
                              target="_blank"
                              rel="noopener noreferrer"
                              onClick={() => handleViewPaper(item)}
                              className="text-[14px] flex items-center hover:text-primary"
                            >
                              View Paper{" "}
                              <HiOutlineArrowNarrowRight className="ml-1" />
                            </a>
                          </div>
                        </motion.div>
                      )
                    )}
                  </div>
                </div>
              ))}
            </div>
          ))}
        </div>
      </section>
    </>
  );
};

export default Practice;
